import axios from 'axios'
import { ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse } from '@/modules/configurationModule/detail/automation/personnel/algorithms-definition/services/configuration-automatic-assignment-algorithm-step-type/configuration-automatic-assignment-algorithm-step-type.dto'

class ConfigurationAutomaticAssignmentAlgorithmStepTypeService {
    async get(): Promise<ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse[]> {
        const response = await axios.get<ConfigurationAutomaticAssignmentAlgorithmStepEnumResponse[]>(`/configuration/automaticAssignmentAlgorithmStepTypes`)
        return response.data
    }
}

export const configurationAutomaticAssignmentAlgorithmStepTypeService = new ConfigurationAutomaticAssignmentAlgorithmStepTypeService()
